import { InitialState } from './types'
import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'

const initialState: InitialState = {
  modules: [],
  isFetching: false,
  isProcessModuleRemove: false,
  isProcessModuleCreate: false,
  isProcessRelationRemove: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchModulesList]: state => {
      return {
        ...state,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchModulesListSuccess]: (state, action) => {
      return {
        ...state,
        modules: action.result,
        isFetching: false,
      }
    },
    [actions.fetchModulesListFailure]: (state, action) => {
      return {
        ...state,
        isFetching: false,
        error: action.error,
      }
    },
    [actions.createModuleRelation]: state => {
      return {
        ...state,
        isProcessModuleCreate: true,
      }
    },
    [actions.createModuleRelationSuccess]: state => {
      return {
        ...state,
        isProcessModuleCreate: false,
      }
    },
    [actions.createModuleRelationFailure]: (state, action) => {
      return {
        ...state,
        isProcessModuleCreate: false,
        error: action.error,
      }
    },
    [actions.removeModule]: state => {
      return {
        ...state,
        isProcessModuleRemove: true,
      }
    },
    [actions.removeModuleSuccess]: state => {
      return {
        ...state,
        isProcessModuleRemove: false,
      }
    },
    [actions.removeModuleFailure]: (state, action) => {
      return {
        ...state,
        isProcessModuleRemove: false,
        error: action.error,
      }
    },
    [actions.removeModuleRelation]: state => {
      return {
        ...state,
        isProcessRelationRemove: true,
      }
    },
    [actions.removeModuleRelationSuccess]: state => {
      return {
        ...state,
        isProcessRelationRemove: false,
      }
    },
    [actions.removeModuleRelationFailure]: (state, action) => {
      return {
        ...state,
        isProcessRelationRemove: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
